import feasbilityRegistry from './feasibility/enhancerEntry';
import geoRegistry from './geo/enhancerEntry';
import getEnhancer from './getWorkerEnhancer';
import productSpaceRegistry from './network/enhancerEntry';
import ringsRegistry from './rings/enhancerEntry';
import stackRegistry from './stack/enhancerEntry';

const enhancer = getEnhancer([
  ringsRegistry,
  stackRegistry as any as typeof ringsRegistry,
  productSpaceRegistry as any as typeof ringsRegistry,
  feasbilityRegistry as any as typeof ringsRegistry,
  geoRegistry as any as typeof ringsRegistry,
]);
export default enhancer;
